import React from 'react';
import { useSelector } from 'react-redux';
import {
  View,
} from '@uncinc/react-drupal-core';
import { APP_OPTIONS, VACANCY_OVERVIEW_URL } from '../../../config/constants';

import './style.scss';

const articles = { type: 'articles', link: '/nl/artikelen' };
const stories = { type: 'stories', link: '/nl/verhalen' };
const vacancies = { type: 'vacancies', link: VACANCY_OVERVIEW_URL };
const projects = { type: 'projects', link: APP_OPTIONS.parameters.links.viewAllProjects };

const links = {
  block_1: articles,
  block_2: articles,
  block_3: projects,
  block_4: projects,
  block_5: vacancies,
  block_6: vacancies,
  block_7: stories,
  block_8: stories,
};

const ARTICLE_BLOCKS = ['block_1', 'block_2'];

const ParagraphRecentContent = ({ id, entity }) => {
  const articleType = entity.getIn(['field_article_type', 0, 'target_id'], null);
  const display = entity.getIn(['field_type_of_content', 0, 'value']);
  const title = entity.getIn(['field_title', 0, 'value']);
  // Overwrite with custom Link, if set
  const attrData = links[display];
  attrData.link = entity.getIn(['field_link', 0, 'alias'], attrData.link);

  // pass argument only if display is article or article groot
  let args;
  if (ARTICLE_BLOCKS.includes(display)) {
    args = articleType ? [articleType] : ['all'];
  }

  return (
    <div id={id} className="Paragraph ParagraphRecentContent row">
      <div className="ParagraphRecentContent__inner col-12">
        {/* Start Content */}
        <View
          className="ParagraphLatestArticles__view"
          id="recent_articles"
          display={display}
          args={args}
          title={title}
          attr={attrData}
          key={`latest_articles_${display}`}
        />
        {/* End Content */}
      </div>
    </div>
  );
};

export default ParagraphRecentContent;
